import classNames from 'classnames';

import { useAnchorable } from '../../hooks/useAnchorable';

import { fileAttachmentContainer, fileAttachmentContent } from './FileAttachment.css';
import type { TPostFileAttachmentProps } from './FileAttachment.types';

export const PostFileAttachment = ({
  className,
  element,
  rewriteImageSrc,
  isIndexingDisabled,
  thumbnailContent,
  thumbnailActions,
}: TPostFileAttachmentProps) => {
  const { name, size, title, description, data } = element.attrs;

  const { anchorAttributes } = useAnchorable(element.attrs);

  // TODO: i18n
  const fileType = `${data?.file_type} File`;
  const imageUrl = rewriteImageSrc && data?.image_url ? rewriteImageSrc(data.image_url) : data?.image_url;

  return (
    <div {...anchorAttributes} className={classNames(fileAttachmentContainer, className)}>
      <div className={fileAttachmentContent}>
        <div className="flex">
          <div className="mb-4 mr-4 align-top">
            <div
              className="relative flex items-center justify-center rounded-[5px] border border-[#d1d5db]"
              data-file-attachment-thumbnail
            >
              <div className="rounded-[5px] border-1 border-solid border-[#d1d5db] w-[75px] h-[75px] overflow-hidden">
                {thumbnailContent || <img src={imageUrl} alt={name} className="w-full h-full object-cover border-0" />}
              </div>
              {thumbnailActions}
            </div>
          </div>
          <div>
            <p className="text-[18px] font-bold leading-[24px]">{title}</p>
            {description && <p className="text-[16px] font-normal leading-[24px] mb-4">{description}</p>}
            <p className="text-[14px] font-normal leading-[24px] text-[#767676]">
              {size} • {fileType}
            </p>
          </div>
        </div>
        <div>
          <a
            href={data?.file_url}
            download={name}
            target="_blank"
            rel={isIndexingDisabled ? 'noreferrer' : undefined}
            className="w-full"
            data-skip-tracking="true"
            data-skip-utms
            data-skip-link-id
          >
            {/* TODO: i18n */}
            <button
              type="button"
              className="w-full cursor-pointer rounded border border-gray-300 bg-white p-[12px] text-sm font-semibold leading-[normal] text-[#282828]"
            >
              Download
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};
